<template >
  <el-dialog
    :title="'附件'"
    :close-on-click-modal="false"
    :visible.sync="visible">
  <el-form style="text-align: left">
    <el-form-item label="图片">

      <el-image v-if="!images || images.length<=0" style="width: 150px; height: 150px">
        <div slot="error" class="image-slot">
          <span>暂无图片</span>
        </div>
      </el-image>
      <el-image
              v-else
              v-for="(item,index) in images"
              style="width: 150px; height: 150px;margin-right: 20px"
              :src="$request.defaults.baseURL+'/bjba/wtsb/queryImgById?id='+item+'&access_token='+$store.getters.token" :preview-src-list="[$request.defaults.baseURL+'/bjba/wtsb/queryImgById?id='+item+'&access_token='+$store.getters.token]"></el-image>
    </el-form-item>

    <el-form-item label="视频">
      <el-image v-if="!form.wtsp" style="width: 150px; height: 150px">
        <div slot="error" class="image-slot">
          <span>暂无视频</span>
        </div>
      </el-image>
      <video v-else style="width: 100%;height: 300px" :src="$request.defaults.baseURL+'/bjba/wtsb/queryVideo?id='+form.questionId+'&access_token='+$store.getters.token" controls="controls"></video>
    </el-form-item>
  </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
<!--<el-button type="primary" @click="dataFormSubmit()">确定</el-button>-->
    </span>
  </el-dialog>
</template>

<script>


  export default {
    data () {
      return {
        visible: false,
        images:[],
        form:{}
      }
    },
    created () {

    },
    methods: {
      init (id) {
        if(!id) return
        this.images=[]
        this.form =id
        this.visible = true
        this.$nextTick(() => {
          this.getIMgIds()
        })
      },
      getIMgIds() {
        let that = this;
        this.$request.get('/bjba/wtsb/getImgIdsByQuestionId/'+this.form.id).then(res => {
          that.images = res.data.data
        })
      },




    }
  }
</script>

<style lang="scss" >
  #left .el-form-item__content{
    text-align: left;
  }
  .menu-list__input,
  .icon-list__input {

    > .el-input__inner {
      cursor: pointer;
    }

  }

  .mod-menu__icon-popover {
    max-width: 350px;
  }
  .image-slot{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 14px;
  }
  .mod-menu__icon-list {
    max-height: 380px;
    padding: 0;
    margin: -8px 0 0 -8px;

    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;

      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }

    }
  }

  .icon-list__tips {
    font-size: 18px;
    text-align: center;
    color: #e6a23c;
    cursor: pointer;
  }
</style>
